unable to read source [project]/frontend/node_modules/src/camera/factories.ts